import { get } from 'modules/api';

/**
 *
 * @returns Promise
 */
export const getUserInfo = () => get('me/');

/**
 *
 * @returns Promise
 */
export const getMyInvoices = () => get('me/invoices');
